import { render, staticRenderFns } from "./workflow.html?vue&type=template&id=38f8bd62&scoped=true&"
import script from "./workflow.js?vue&type=script&lang=js&"
export * from "./workflow.js?vue&type=script&lang=js&"
import style0 from "./workflow.scss?vue&type=style&index=0&id=38f8bd62&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f8bd62",
  null
  
)

export default component.exports